/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./NoteSearch.component";
var styles_NoteSearchComponent = ["[_nghost-%COMP%] {\n      position: fixed;\n      right: 15px;\n      top: 70px;\n      width: 325px;\n      z-index: 1;\n    }"];
var RenderType_NoteSearchComponent = i0.ɵcrt({ encapsulation: 0, styles: styles_NoteSearchComponent, data: {} });
export { RenderType_NoteSearchComponent as RenderType_NoteSearchComponent };
export function View_NoteSearchComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_NoteSearchComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "nns-note-search", [], null, null, null, View_NoteSearchComponent_0, RenderType_NoteSearchComponent)), i0.ɵdid(1, 49152, null, 0, i1.NoteSearchComponent, [], null, null)], null, null); }
var NoteSearchComponentNgFactory = i0.ɵccf("nns-note-search", i1.NoteSearchComponent, View_NoteSearchComponent_Host_0, {}, {}, []);
export { NoteSearchComponentNgFactory as NoteSearchComponentNgFactory };
//# sourceMappingURL=NoteSearch.component.ngfactory.js.map